var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.roleList[_vm.path].includes(_vm.permissionName))?_c('el-button',{attrs:{"icon":_vm.icon,"size":_vm.size,"type":_vm.btnType},on:{"click":_vm.handleDownload}},[_vm._v("导出")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }